<div id="adminWrapper" class="containerWrapper" *ngIf="loginService.getCurrentUser().admin">
  <!-- <mat-progress-bar mode="indeterminate" *ngIf="showTemplatesProgress"></mat-progress-bar> -->
  <h1>{{ 'Admin Settings' | translate }}</h1>
  <div id="loginAsUser" class="adminSmallWidget">
        <h2>{{ 'Login as User' | translate }}</h2>
        <div class="adminInnerContainer">
            <ul>
                <li>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'Type email of user' | translate }}</mat-label>
                    <input matInput [placeholder]="'bassam.tarek@creiden.com' | translate" id="loginProjectDomain" (change)="updateLoginValue($event)" value="{{this.loginProjectDomain}}">
                </mat-form-field>
                <button href="#" class="stacksBtn blue" (click)="loginAsUser()">{{ 'Login' | translate }}</button> 
                </li>
            </ul>
        </div>
    </div>
  <div class="adminSmallWidget">
    <h2>{{ 'Admin analytics' | translate }}</h2>
    <div class="adminInnerContainer">
      <ul class="linksList">
        <li [routerLink]="['self']">{{ 'Self' | translate }}</li>
        <li [routerLink]="['cloud']">{{ 'Cloud' | translate }}</li>
        <li [routerLink]="['logs']">{{ 'Logs' | translate }}</li>
        <li [routerLink]="['apps-uploaded']">{{ 'Apps Uploaded' | translate }}</li>
        <li [routerLink]="['all-apps']">{{ 'All Apps' | translate }}</li>
        <li [routerLink]="['dynamicSamples']">{{ 'Dynamic Samples' | translate }}</li>
        <li [routerLink]="['ordersStats']">{{ 'Orders Stats' | translate }}</li>
      </ul>
    </div>
  </div>
  <div class="adminSmallWidget">
    <h2>{{ 'Admin Settings' | translate }}</h2>
    <div class="adminInnerContainer">
      <button class="stacksBtn blue" (click)="cancelAllBuilds()">{{ 'Cancel All Builds' | translate }}</button>
  </div>
</div>
